import { useEffect, useState } from "react";
import axios from "../../../config/axios";
import { useParams } from "react-router-dom";

const useOnlineReservation = () => {
  const [onlineReservation, setOnlineReservation] = useState(null);
  const { token } = useParams();

  useEffect(() => {
    let current = true;
    setOnlineReservation(null);
    axios
      .get(`/online_reservations/${token}.json`)
      .then(function (response) {
        if (current) setOnlineReservation(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
    return () => {
      current = false;
    };
  }, [token]);

  const update = async (onlineReservation) => {
    const response = await axios.put(
      `/online_reservations/${onlineReservation.token}.json`,
      { online_reservation: onlineReservation }
    );
    setOnlineReservation(response.data);
    return response.data;
  };

  return { update, onlineReservation };
};
export default useOnlineReservation;
